// @flow
import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { SUBTITLES_HIDDEN, TRANSCRIPTION_DISABLED, TRANSCRIPTION_LANGUAGE_COPIED } from './actionTypes';
export const DEFAULT_STATE = {
    isTranscriptionDisabled: null,
    isSubtitlesHidden: true,
    transcriptionLanguageCopied: '',
    transcriptionCode: null
};
ReducerRegistry.register('wildix/features/transcribing', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case TRANSCRIPTION_DISABLED:
            return {
                ...state,
                isTranscriptionDisabled: action.isTranscriptionDisabled
            };
        case SUBTITLES_HIDDEN:
            return {
                ...state,
                isSubtitlesHidden: action.isSubtitlesHidden
            };
        case TRANSCRIPTION_LANGUAGE_COPIED:
            return {
                ...state,
                transcriptionLanguageCopied: action.transcriptionLanguageCopied,
                transcriptionCode: action.transcriptionCode
            };
        default:
            return state;
    }
});
